
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"41","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3677F6","d":"M31.855 6.67H8.145c-.813 0-1.478.664-1.478 1.477v9.815c0 .814.665 1.479 1.478 1.479h23.71c.813 0 1.478-.665 1.478-1.479V8.147c0-.813-.65-1.478-1.478-1.478z"}}),_c('path',{attrs:{"fill":"#BFD8FB","d":"M13.703 21.628H8.145c-.813 0-1.478.666-1.478 1.479v8.75c0 .814.665 1.479 1.478 1.479h5.558c.813 0 1.478-.665 1.478-1.478v-8.751c0-.813-.665-1.479-1.478-1.479z"}}),_c('path',{attrs:{"fill":"#70A0FF","d":"M31.855 21.628H19.216c-.813 0-1.478.666-1.478 1.479v8.75c0 .814.666 1.479 1.479 1.479h12.638c.813 0 1.478-.665 1.478-1.478v-8.751c0-.813-.65-1.479-1.478-1.479z"}})])
          )
        }
      }
    